import React, { useEffect } from 'react'
import { motion } from "framer-motion";
import { Link } from 'react-router-dom';
import FooterContact from '../../component/FooterContact';
import HomeVideo2 from '../../assets/images/banner/banner-1.mp4';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Pagination, Autoplay } from 'swiper/modules';

const partnerImages = [
    'partner-1.webp','partner-2.webp','partner-3.webp','partner-4.webp',
    'partner-5.webp','netskope.png','partner-6.webp','partner-7.webp',
    'partner-8.webp','partner-9.webp','partner-10.webp','partner-11.webp',
    'partner-12.webp','partner-13.webp','partner-14.webp','partner-15.webp',
    'partner-16.webp','partner-17.webp','partner-18.webp','partner-19.webp',
    'partner-20.webp','partner-21.webp','partner-22.webp','partner-23.webp',
    'partner-24.webp','partner-25.webp','partner-26.webp','partner-27.webp',
    'partner-28.webp',
];

const advancements = [
    {
        icon: 'fa-shield',
        title: 'Network & Infrastructure Security',
        desc: 'Technical Assurance Services for a Secure Cloud Computing Transition',
        link: '/enterprise-network-ndr',
    },
    {
        icon: 'fa-cloud',
        title: 'Cloud Security',
        desc: 'Industrial Control Systems Security to protect Critical Infrastructure',
        link: '/cloud',
    },
    {
        icon: 'fa-cogs',
        title: 'ICS / OT Security',
        desc: 'Hunting Cyber Adversaries with SOC as a Service by DTS',
        link: '/ics-security',
    },
    {
        icon: 'fa-eye',
        title: '24×7 Managed CSOC & MDR',
        desc: 'Advanced Next Generation Enterprise Network Security',
        link: '/mdr',
    },
];

const testimonials = [
    { quote: '"CLOUD MIND has been a game changer for our cybersecurity strategy. Their comprehensive protection across our email, cloud, and network systems has kept our data secure from evolving threats."', author: 'IT Director', company: 'Manufacturing' },
    { quote: '"We turned to CLOUD MIND for a complete overhaul of our cybersecurity protocols, and it was the best decision we made. Their expert team implemented robust security measures making us feel protected against even the most sophisticated cyberattacks."', author: 'Chief Information Security Officer', company: 'Manufacturing' },
    { quote: '"CLOUD MIND\'s email security and network defense solutions have been critical in preventing cyber threats from affecting our operations. We\'ve seen a significant reduction in phishing attempts and other security breaches."', author: 'Operations Manager', company: 'Agriculture' },
    { quote: '"Since partnering with CLOUD MIND, our network and cloud systems have been fortified with state-of-the-art security protocols. They helped us integrate advanced encryption ensuring compliance and protecting our clients\' data."', author: 'Founder', company: 'Healthcare' },
    { quote: '"CLOUD MIND has delivered unmatched expertise in securing our cloud services and networks. Their end-to-end cybersecurity solutions have helped us prevent data breaches and avoid costly downtime."', author: 'CTO', company: 'Real Estate' },
    { quote: '"The cybersecurity solutions provided by CLOUD MIND have given us a level of confidence that we didn\'t have before. Their response time to potential threats is outstanding."', author: 'Head of Technology', company: 'Transportation' },
];

const fadeUp = {
    hidden: { opacity: 0, y: 40 },
    visible: (i = 0) => ({ opacity: 1, y: 0, transition: { duration: 0.6, delay: i * 0.1 } }),
};

export default function Partners() {
    useEffect(() => { window.scrollTo(0, 0); }, []);

    return (
        <>
            {/* ── HERO BANNER ── */}
            <section style={{ position: 'relative', overflow: 'hidden', minHeight: '520px', display: 'flex', alignItems: 'center' }}>
                <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(120deg, rgba(0,0,0,0.82) 45%, rgba(230,82,0,0.18) 100%)', zIndex: 1 }} />
                <video autoPlay loop muted style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', zIndex: 0 }}>
                    <source src={HomeVideo2} type="video/mp4" />
                </video>
                <div className="container" style={{ position: 'relative', zIndex: 2, padding: '100px 15px 80px' }}>
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-md-12">
                            <motion.div initial="hidden" animate="visible" variants={fadeUp}>
                                <nav style={{ marginBottom: '18px' }}>
                                    <span style={{ color: '#aaa', fontSize: '13px' }}>
                                        <Link to="/" style={{ color: '#aaa', textDecoration: 'none' }}>Home</Link>
                                        <span style={{ margin: '0 8px', color: '#e65200' }}>›</span>
                                        <span style={{ color: '#fff' }}>Partners</span>
                                    </span>
                                </nav>
                                <h1 style={{ fontSize: 'clamp(2.4rem, 5vw, 4rem)', fontWeight: 800, color: '#fff', lineHeight: 1.15, marginBottom: '18px' }}>
                                    Our Global <span style={{ color: '#e65200' }}>Partners</span>
                                </h1>
                                <p style={{ color: '#ccc', fontSize: '1.1rem', lineHeight: 1.7, maxWidth: '480px', marginBottom: '32px' }}>
                                    We come together with world-class technology leaders to enhance your experience and propel business success.
                                </p>
                                <Link to="/contact">
                                    <button style={{
                                        background: 'linear-gradient(135deg, #e65200, #ff8c00)',
                                        color: '#fff', border: 'none', padding: '14px 36px',
                                        borderRadius: '50px', fontWeight: 700, fontSize: '15px',
                                        cursor: 'pointer', boxShadow: '0 8px 32px rgba(230,82,0,0.35)',
                                        transition: 'transform 0.2s',
                                    }}
                                        onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-3px)'}
                                        onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}
                                    >Contact Us →</button>
                                </Link>
                            </motion.div>
                        </div>
                        <div className="col-lg-6 col-md-12 text-center" style={{ marginTop: '30px' }}>
                            <motion.img
                                src={require('../../assets/images/services/products/data-bg-transparant.webp')}
                                alt="Partners"
                                initial={{ opacity: 0, scale: 0.88 }}
                                animate={{ opacity: 1, scale: 1 }}
                                transition={{ duration: 0.9, delay: 0.2 }}
                                style={{ maxWidth: '100%', filter: 'drop-shadow(0 20px 60px rgba(230,82,0,0.25))' }}
                            />
                        </div>
                    </div>
                </div>
                {/* Decorative bottom wave */}
                <svg style={{ position: 'absolute', bottom: 0, left: 0, width: '100%', zIndex: 2 }} viewBox="0 0 1440 60" preserveAspectRatio="none">
                    <path d="M0,60 C360,0 1080,80 1440,20 L1440,60 Z" fill="#0a0a0a" />
                </svg>
            </section>

            {/* ── STATS STRIP ── */}
            <div style={{ background: 'linear-gradient(90deg, #111 0%, #1a1a1a 100%)', borderBottom: '1px solid #222' }}>
                <div className="container">
                    <div className="row text-center" style={{ padding: '36px 0' }}>
                        {[['28+', 'Technology Partners'], ['8+', 'Years of Excellence'], ['500+', 'Projects Delivered'], ['24/7', 'Expert Support']].map(([num, label], i) => (
                            <motion.div key={i} className="col-6 col-md-3" custom={i} initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeUp}>
                                <div style={{ padding: '10px' }}>
                                    <div style={{ fontSize: 'clamp(1.8rem, 3vw, 2.6rem)', fontWeight: 800, background: 'linear-gradient(135deg, #e65200, #ff8c00)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>{num}</div>
                                    <div style={{ color: '#aaa', fontSize: '13px', fontWeight: 500, letterSpacing: '0.05em', textTransform: 'uppercase', marginTop: '4px' }}>{label}</div>
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </div>

            {/* ── PARTNER LOGOS GRID ── */}
            <section style={{ background: '#0d0d0d', padding: '80px 0' }}>
                <div className="container">
                    <motion.div initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeUp} style={{ textAlign: 'center', marginBottom: '56px' }}>
                        <span style={{ color: '#e65200', fontSize: '13px', fontWeight: 700, letterSpacing: '0.15em', textTransform: 'uppercase' }}>Trusted By Industry Leaders</span>
                        <h2 style={{ color: '#fff', fontSize: 'clamp(1.8rem, 3.5vw, 2.8rem)', fontWeight: 800, marginTop: '12px', marginBottom: '16px' }}>Our Partners</h2>
                        <div style={{ width: '60px', height: '4px', background: 'linear-gradient(90deg, #e65200, #ff8c00)', borderRadius: '2px', margin: '0 auto' }} />
                    </motion.div>
                    <div className="row" style={{ gap: '0' }}>
                        {partnerImages.map((img, i) => (
                            <motion.div key={i} className="col-lg-3 col-md-4 col-6"
                                custom={i % 8} initial="hidden" whileInView="visible" viewport={{ once: true, margin: '-60px' }} variants={fadeUp}
                                style={{ padding: '10px' }}
                            >
                                <div style={{
                                    background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)',
                                    borderRadius: '16px', padding: '24px 20px', display: 'flex', alignItems: 'center',
                                    justifyContent: 'center', minHeight: '100px', transition: 'all 0.35s ease',
                                    backdropFilter: 'blur(6px)',
                                }}
                                    onMouseEnter={e => {
                                        e.currentTarget.style.background = 'rgba(230,82,0,0.08)';
                                        e.currentTarget.style.border = '1px solid rgba(230,82,0,0.35)';
                                        e.currentTarget.style.transform = 'translateY(-6px)';
                                        e.currentTarget.style.boxShadow = '0 16px 40px rgba(230,82,0,0.15)';
                                    }}
                                    onMouseLeave={e => {
                                        e.currentTarget.style.background = 'rgba(255,255,255,0.04)';
                                        e.currentTarget.style.border = '1px solid rgba(255,255,255,0.08)';
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.boxShadow = 'none';
                                    }}
                                >
                                    <img src={require(`../../assets/images/partner/${img}`)} alt="" style={{ maxWidth: '100%', maxHeight: '60px', objectFit: 'contain', filter: 'brightness(0.9) contrast(1.05)' }} />
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ── ABOUT / TRUST SECTION ── */}
            <section style={{ background: '#111', padding: '100px 0' }}>
                <div className="container">
                    <div className="row align-items-center" style={{ gap: '40px 0' }}>
                        <div className="col-lg-6">
                            <motion.div initial={{ opacity: 0, x: -50 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.7 }} style={{ position: 'relative' }}>
                                <div style={{
                                    position: 'absolute', top: '-20px', left: '-20px', right: '20px', bottom: '20px',
                                    border: '2px solid rgba(230,82,0,0.25)', borderRadius: '24px', zIndex: 0,
                                }} />
                                <img src={require('../../assets/images/partner.webp')} alt="Partners"
                                    style={{ width: '100%', borderRadius: '20px', position: 'relative', zIndex: 1, boxShadow: '0 30px 80px rgba(0,0,0,0.5)' }} />
                                <div style={{
                                    position: 'absolute', bottom: '-16px', right: '-16px', zIndex: 2,
                                    background: 'linear-gradient(135deg, #e65200, #ff8c00)',
                                    borderRadius: '16px', padding: '18px 24px', textAlign: 'center',
                                    boxShadow: '0 10px 30px rgba(230,82,0,0.4)',
                                }}>
                                    <div style={{ color: '#fff', fontSize: '2rem', fontWeight: 800 }}>100%</div>
                                    <div style={{ color: 'rgba(255,255,255,0.85)', fontSize: '12px', fontWeight: 600, letterSpacing: '0.05em' }}>TRANSPARENT</div>
                                </div>
                            </motion.div>
                        </div>
                        <div className="col-lg-6">
                            <motion.div initial={{ opacity: 0, x: 50 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.7 }} style={{ paddingLeft: '20px' }}>
                                <span style={{ color: '#e65200', fontSize: '13px', fontWeight: 700, letterSpacing: '0.15em', textTransform: 'uppercase' }}>Partnership Philosophy</span>
                                <h2 style={{ color: '#fff', fontSize: 'clamp(1.6rem, 3vw, 2.4rem)', fontWeight: 800, margin: '16px 0 24px', lineHeight: 1.3 }}>
                                    Our Partners Trust in <span style={{ color: '#e65200' }}>Our Vision</span>
                                </h2>
                                <p style={{ color: '#bbb', lineHeight: 1.85, fontSize: '1.02rem', marginBottom: '28px' }}>
                                    We collaborate with a diverse range of technology partners to fulfill your business requirements. With complete transparency in our partnerships, you can be confident that you're always receiving the best solutions at the most competitive price.
                                </p>
                                {['Global Technology Ecosystem', 'Best-in-Class Solutions', 'Verified Vendor Relationships'].map((item, i) => (
                                    <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '14px' }}>
                                        <div style={{ width: '28px', height: '28px', borderRadius: '50%', background: 'linear-gradient(135deg, #e65200, #ff8c00)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                            <i className="fa fa-check" style={{ color: '#fff', fontSize: '12px' }} />
                                        </div>
                                        <span style={{ color: '#ddd', fontWeight: 500 }}>{item}</span>
                                    </div>
                                ))}
                            </motion.div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ── CYBER ADVANCEMENTS ── */}
            <section style={{ background: 'linear-gradient(135deg, #0a0a0a 0%, #111827 100%)', padding: '100px 0', position: 'relative', overflow: 'hidden' }}>
                <div style={{ position: 'absolute', top: '10%', right: '-80px', width: '400px', height: '400px', borderRadius: '50%', background: 'radial-gradient(circle, rgba(230,82,0,0.08) 0%, transparent 70%)', pointerEvents: 'none' }} />
                <div className="container" style={{ position: 'relative', zIndex: 1 }}>
                    <motion.div initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeUp} style={{ textAlign: 'center', marginBottom: '60px' }}>
                        <span style={{ color: '#e65200', fontSize: '13px', fontWeight: 700, letterSpacing: '0.15em', textTransform: 'uppercase' }}>Solutions</span>
                        <h2 style={{ color: '#fff', fontSize: 'clamp(1.8rem, 3.5vw, 2.8rem)', fontWeight: 800, marginTop: '12px', marginBottom: '16px' }}>
                            Boost Your Cyber Security <span style={{ color: '#e65200' }}>Advancements</span>
                        </h2>
                        <div style={{ width: '60px', height: '4px', background: 'linear-gradient(90deg, #e65200, #ff8c00)', borderRadius: '2px', margin: '0 auto' }} />
                    </motion.div>
                    <div className="row">
                        {advancements.map((item, i) => (
                            <motion.div key={i} className="col-lg-3 col-md-6" custom={i} initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeUp} style={{ padding: '12px' }}>
                                <div style={{
                                    background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.08)',
                                    borderRadius: '20px', padding: '36px 28px', height: '100%',
                                    transition: 'all 0.35s ease', position: 'relative', overflow: 'hidden',
                                }}
                                    onMouseEnter={e => {
                                        e.currentTarget.style.background = 'rgba(230,82,0,0.07)';
                                        e.currentTarget.style.border = '1px solid rgba(230,82,0,0.3)';
                                        e.currentTarget.style.transform = 'translateY(-8px)';
                                        e.currentTarget.style.boxShadow = '0 20px 60px rgba(230,82,0,0.15)';
                                    }}
                                    onMouseLeave={e => {
                                        e.currentTarget.style.background = 'rgba(255,255,255,0.03)';
                                        e.currentTarget.style.border = '1px solid rgba(255,255,255,0.08)';
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.boxShadow = 'none';
                                    }}
                                >
                                    <div style={{ width: '52px', height: '52px', borderRadius: '14px', background: 'linear-gradient(135deg, #e65200, #ff8c00)', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '22px', boxShadow: '0 8px 20px rgba(230,82,0,0.3)' }}>
                                        <i className={`fa ${item.icon}`} style={{ color: '#fff', fontSize: '20px' }} />
                                    </div>
                                    <h3 style={{ color: '#fff', fontSize: '1.1rem', fontWeight: 700, marginBottom: '14px', lineHeight: 1.4 }}>{item.title}</h3>
                                    <p style={{ color: '#888', fontSize: '14px', lineHeight: 1.7, marginBottom: '24px' }}>{item.desc}</p>
                                    <Link to={item.link} style={{
                                        display: 'inline-flex', alignItems: 'center', gap: '8px',
                                        color: '#e65200', fontWeight: 600, fontSize: '14px', textDecoration: 'none',
                                        transition: 'gap 0.2s',
                                    }}
                                        onMouseEnter={e => e.currentTarget.style.gap = '14px'}
                                        onMouseLeave={e => e.currentTarget.style.gap = '8px'}
                                    >
                                        Learn More <i className="fa fa-arrow-right" style={{ fontSize: '12px' }} />
                                    </Link>
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ── TESTIMONIALS ── */}
            <section style={{
                backgroundImage: 'url(' + require('../../assets/images/home/asdf.jpg') + ')',
                backgroundSize: 'cover', backgroundPosition: 'center',
                position: 'relative', padding: '100px 0',
            }}>
                <div style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.78)' }} />
                <div className="container" style={{ position: 'relative', zIndex: 1 }}>
                    <motion.div initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeUp} style={{ textAlign: 'center', marginBottom: '56px' }}>
                        <span style={{ color: '#e65200', fontSize: '13px', fontWeight: 700, letterSpacing: '0.15em', textTransform: 'uppercase' }}>What Clients Say</span>
                        <h2 style={{ color: '#fff', fontSize: 'clamp(1.8rem, 3.5vw, 2.8rem)', fontWeight: 800, marginTop: '12px', marginBottom: '16px' }}>Testimonials</h2>
                        <div style={{ width: '60px', height: '4px', background: 'linear-gradient(90deg, #e65200, #ff8c00)', borderRadius: '2px', margin: '0 auto' }} />
                    </motion.div>
                    <Swiper
                        spaceBetween={24}
                        pagination={{ clickable: true }}
                        breakpoints={{
                            640: { slidesPerView: 1 },
                            768: { slidesPerView: 2 },
                            1024: { slidesPerView: 2 },
                        }}
                        autoplay={{ delay: 3000, disableOnInteraction: false }}
                        modules={[Pagination, Autoplay]}
                        className="testimonialSwiper"
                    >
                        {testimonials.map((t, i) => (
                            <SwiperSlide key={i}>
                                <div style={{
                                    background: 'rgba(255,255,255,0.05)', backdropFilter: 'blur(16px)',
                                    border: '1px solid rgba(255,255,255,0.1)', borderRadius: '20px',
                                    padding: '36px 32px', margin: '10px 4px 50px',
                                    position: 'relative',
                                }}>
                                    <div style={{ color: '#e65200', fontSize: '48px', lineHeight: 0.8, fontFamily: 'Georgia', marginBottom: '20px', opacity: 0.8 }}>"</div>
                                    <p style={{ color: '#ccc', fontSize: '15px', lineHeight: 1.8, marginBottom: '28px', fontStyle: 'italic' }}>{t.quote}</p>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
                                        <div style={{ width: '44px', height: '44px', borderRadius: '50%', background: 'linear-gradient(135deg, #e65200, #ff8c00)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                            <i className="fa fa-user" style={{ color: '#fff', fontSize: '18px' }} />
                                        </div>
                                        <div>
                                            <div style={{ color: '#fff', fontWeight: 700, fontSize: '14px' }}>{t.author}</div>
                                            <div style={{ color: '#e65200', fontSize: '12px', fontWeight: 500 }}>{t.company}</div>
                                        </div>
                                    </div>
                                    <div style={{ position: 'absolute', top: '24px', right: '24px' }}>
                                        {[...Array(5)].map((_, s) => (
                                            <i key={s} className="fa fa-star" style={{ color: '#e65200', fontSize: '12px', marginLeft: '2px' }} />
                                        ))}
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </section>

            <FooterContact />
        </>
    )
}
